// Placeholder type for now - will be replaced by generated code
export interface V1ErrorObject {
  detail: string
  status?: number
  source?: {
    pointer?: string
    header?: string
    parameter?: string
  }
}

export class ApiError extends Error {
  public readonly error: V1ErrorObject
  constructor(error: V1ErrorObject) {
    super(error.detail)
    this.error = error
  }
}
